var _circle, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPublicApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#1072FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8738 46.161V39.6942H51.527V36.4608H50.2336V40.9876H60.5805V46.161H61.8738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7732 35.1686H61.2269C63.7233 35.1686 65.7537 33.138 65.7537 30.6419C65.7537 28.1455 63.7233 26.1152 61.2269 26.1152H59.2869V25.4685C59.2869 21.9026 56.386 19.0017 52.8201 19.0017C50.7206 19.0017 48.7437 20.0317 47.5305 21.7564L47.0016 22.5092L46.4724 21.7564C45.2599 20.0317 43.2817 19.0017 41.18 19.0017C37.6144 19.0017 34.7132 21.9026 34.7132 25.4685L34.6908 26.4669L33.9029 26.2639C33.5171 26.1641 33.1407 26.1152 32.7706 26.1152C32.2831 26.1152 31.806 26.2017 31.3298 26.3757C29.4293 27.071 28.2193 28.7716 28.2464 30.7085C28.2821 33.1677 30.3128 35.1686 32.7732 35.1686ZM48.9401 28.7019H50.2334V29.9952H48.9401V28.7019ZM46.3534 28.7019H47.6467V29.9952H46.3534V28.7019ZM43.7667 28.7019H45.06V29.9952H43.7667V28.7019ZM51.5268 31.2886V28.7019H52.8201V32.5819H38.5932V31.2886H51.5268ZM41.18 20.2951V21.5884C39.0404 21.5884 37.2999 23.3286 37.2999 25.4685H36.0065C36.0065 22.6159 38.3277 20.2951 41.18 20.2951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1267 39.6942V46.161H33.4201V40.9876H43.7669V36.4608H42.4735V39.6942H32.1267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4735 56.5077H51.527V52.6277H42.4735V56.5077ZM48.2936 53.921H49.587V55.2144H48.2936V53.921ZM44.4135 53.921H45.7069V55.2144H44.4135V53.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4735 51.3344H51.527V47.4543H42.4735V51.3344ZM48.2936 48.7477H49.587V50.0411H48.2936V48.7477ZM44.4135 48.7477H45.7069V50.0411H44.4135V48.7477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2467 56.5077H37.3002V52.6277H28.2467V56.5077ZM34.0668 53.921H35.3601V55.2144H34.0668V53.921ZM30.1867 53.921H31.4801V55.2144H30.1867V53.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2467 51.3344H37.3002V47.4543H28.2467V51.3344ZM34.0668 48.7477H35.3601V50.0411H34.0668V48.7477ZM30.1867 48.7477H31.4801V50.0411H30.1867V48.7477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3536 36.4608H47.647V46.161H46.3536V36.4608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7004 51.3344H65.7539V47.4543H56.7004V51.3344ZM62.5205 48.7477H63.8139V50.0411H62.5205V48.7477ZM58.6405 48.7477H59.9338V50.0411H58.6405V48.7477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7004 56.5077H65.7539V52.6277H56.7004V56.5077ZM62.5205 53.921H63.8139V55.2144H62.5205V53.921ZM58.6405 53.921H59.9338V55.2144H58.6405V53.921Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.565 59.1577H49.9403C50.8544 56.6317 53.3306 54.877 56.134 54.877C58.9555 54.877 61.4445 56.6547 62.3448 59.2058C64.6542 59.511 66.5113 61.2302 66.9721 63.4385H67.0822C69.4975 63.4385 71.4615 65.3583 71.4615 67.7193C71.4615 70.0802 69.4975 72 67.0822 72H49.565C45.9427 72 42.9231 69.1197 42.9231 65.5789C42.9231 62.038 45.9427 59.1577 49.565 59.1577Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4351 59.1577H44.0598C43.1457 56.6317 40.6695 54.877 37.8661 54.877C35.0446 54.877 32.5556 56.6547 31.6553 59.2058C29.3459 59.511 27.4888 61.2302 27.028 63.4385H26.9179C24.5026 63.4385 22.5386 65.3583 22.5386 67.7193C22.5386 70.0802 24.5026 72 26.9179 72H44.4351C48.0574 72 51.077 69.1197 51.077 65.5789C51.077 62.038 48.0574 59.1577 44.4351 59.1577Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5077,
    height: 37.5077,
    fill: "white",
    transform: "translate(28.2463 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublicApi);
export default __webpack_public_path__ + "static/media/icon_public-api.24477c0dc0ebda7e66872f3db9e1bfa0.svg";
export { ForwardRef as ReactComponent };